import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead } from "@/components/site/Motion";
import { TripCard } from "@/components/site/TripCard";
import { useTrips } from "@/hooks/useTrips";
import { T } from "@/context/ContentContext";

const TABS = [["all", "All"], ["india", "India"], ["international", "International"]];

export function UpcomingTrips() {
  const { trips, loading } = useTrips();
  const [tab, setTab] = useState("all");
  const list = trips.filter((t) => tab === "all" || t.region === tab).slice(0, 8);

  return (
    <section className="bg-cream py-24 sm:py-32" data-testid="upcoming-trips-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHead k="home.upcoming" eyebrow="Upcoming departures" title={["Trips leaving", "soon."]}>
          <div className="flex items-center gap-2 rounded-full bg-paper p-1.5 self-start md:self-auto" role="tablist">
            {TABS.map(([k, label]) => (
              <button key={k} onClick={() => setTab(k)} data-testid={`upcoming-tab-${k}`} role="tab" aria-selected={tab === k}
                className={`rounded-full px-4 sm:px-5 py-2 text-sm font-medium transition-colors duration-300 ${tab === k ? "bg-ink text-cream" : "text-ink/70 hover:text-ink"}`}>
                <T k={`home.upcoming.tab.${k}`}>{label}</T>
              </button>
            ))}
          </div>
        </SectionHead>
        {loading && <p className="eyebrow text-stone-600">Loading trips…</p>}
        <div className="flex lg:grid lg:grid-cols-4 gap-6 overflow-x-auto lg:overflow-visible snap-x snap-mandatory no-scrollbar -mx-5 px-5 lg:mx-0 lg:px-0 pb-2">
          {list.map((t, i) => (
            <Reveal key={t.id} delay={(i % 4) * 0.08} className="snap-start shrink-0 w-[78%] sm:w-[45%] lg:w-auto">
              <TripCard trip={t} />
            </Reveal>
          ))}
        </div>
        <Link to="/trips" data-testid="upcoming-view-all-link"
          className="group mt-14 inline-flex items-center gap-3 rounded-full border border-ink/20 px-6 py-3 font-semibold hover:bg-ink hover:text-cream transition-colors duration-300">
          <T k="home.upcoming.all">View all trips</T> <ArrowUpRight className="h-4 w-4 transition-transform group-hover:rotate-45" />
        </Link>
      </div>
    </section>
  );
}
